import request from '@utils/request'
import { groupById } from '@utils/normalize-data'
export const state = {
  cached: [],
  byId: {},
  byPriceId: {},
}

export const getters = {}

export const mutations = {
  CACHE_PRODUCTS(state, currentProducts) {
    state.cached = currentProducts
    state.byId = groupById(currentProducts, 'products')
  },
  CACHE_PRICES(state, currentPrices) {
    state.byPriceId = groupById(currentPrices, 'products')
  },
}

export const actions = {
  fetchPrices({ commit }, { productId, query }) {
    return request
      .post(`/admin/product/${productId}/price/search`, {
        paginate: 0,
        ...query,
      })
      .then((response) => response.items)
  },
  storePrices({ commit }, { productId, storeData, inventoryId = undefined }) {
    return request.post(`/admin/product/${productId}/price/store`, {
      inventoryId,
      params: storeData,
    })
  },
  inventoryCalendar({ commit }, { productId, submitData }) {
    return request.post(`/admin/product/${productId}/calendar`, submitData)
  },
  store({ commit }, storeData) {
    return request.post('/admin/product/store', storeData).then((response) => response && response.items)
  },
  updateState({ commit }, { ids, state } = {}) {
    return request.post('/admin/product/state', { ids, state })
  },
  remove({ commit }, { ids }) {
    return request.post('/admin/product/remove', { ids })
  },
  serviceRemove({ commit }, { ids }) {
    return request.post('/admin/service/remove', { ids })
  },
  fetchSingle({ commit }, productId) {
    return request.get(`/admin/product/${productId}`).then((response) => response.items)
  },
  fetchList({ commit }, query) {
    return request.post('/admin/product/search', query).then(({ items, modulesLimit, modulesUsed, pagination: { total } }) => {
      commit('CACHE_PRODUCTS', items)
      return {
        items,
        modulesLimit,
        modulesUsed,
        total,
      }
    })
  },
  updateExtraField({ commit }, submitData) {
    return request.post(`/admin/product/order/extrafield/store`, submitData).then((response) => response.items)
  },
  fetchExtraField({ commit }, query) {
    return request.post('/admin/product/order/extrafield/search', query).then((response) => response.items)
  },
  // 服務項目(old)
  fetchServicePrices({ commit }, query) {
    return request.post(`/admin/product/price/search`, query).then(({ items, pagination: { total, current_page } }) => {
      commit('CACHE_PRICES', items)
      return {
        items,
        total,
        current_page,
      }
    })
  },
  fetchServicePriceGroup({ commit }, query) {
    return request.post(`/admin/product/price/search`, query).then((items) => {
      // commit('CACHE_PRICES', items)
      return items
    })
  },
  /**
   * @description 一般服務 -> search
   */
  fetchNormalServiceData({ commit }, query) {
    return request.post(`/admin/service/search`, query).then((items) => {
      return items
    })
  },
  /**
   * @description 庫存管理搜尋
   */
  fetchInventoryHistory({ commit }, query) {
    return request.post(`/admin/service/inventory/history/search`, query).then((items) => {
      return items
    })
  },
  fetchServicePricesByGroup({ commit }) {
    return request.post(`/admin/product/price/search`, { groupByPetSize: 1 }).then((response) => {
      response.forEach((store) => {
        store.children.forEach((price) => {
          price.children.forEach((item) => {
            item.maxTimes = 0
          })
        })
      })
      return response
    })
  },
  storeServicePrice({ commit }, submitData) {
    return request.post(`/admin/product/${submitData.productId}/price/store`, submitData)
  },
  /**
   * @description 美容服務 -> 一般服務 -> 點選其中一列之後的儲存
   */
  storeServicePriceGroup({ commit }, submitData) {
    let data = {
      ...submitData,
      images: submitData.images.map((image, index) => {
        return {
          ...image,
          default: index === 0 ? 1 : 0,
        }
      }),
    }
    return request.post(`/admin/service/store`, data)
  },
  /**
   * @description 美容服務 -> Spa服務 -> 點選其中一列之後的儲存
   */
  storeServiceSpaGroup({ commit }, submitData) {
    let data = {
      ...submitData,
      images: submitData.images.map((image, index) => {
        return {
          default: index === 0 ? 1 : 0,
          type: 'image',
          path: image.path || '',
        }
      }),
      storeIds: submitData.storeIds.map((stores) => stores.id),
      sizeIds: submitData.serviceCategoryIds,
      type: '',
      prices: [],
    }
    return request.post(`/admin/service/price/group/store`, data)
  },
  removeServicePrice({ commit }, submitData) {
    return request.post(`/admin/product/${submitData.productId}/price/remove`, submitData)
  },
  fetchSingleServicePrice({ commit }, priceId) {
    return request.get(`/admin/product/price/${priceId}`).then((response) => response.items)
  },
  /**
   * @description 獲取一般服務 or 加購服務 的個別詳細資訊
   * @returns
   */
  fetchSingleServiceData({ commit }, groupOrdering) {
    return request.get(`/admin/service/${groupOrdering}`, {}).then((response) => response.items)
  },
  /**
   * @description 獲取SPA服務的個別詳細資訊
   * @returns
   */
  fetchSingleSpaServiceData({ commit }, groupOrdering) {
    return request.get(`/admin/service/price/group/${groupOrdering}`, {}).then((response) => response.items)
  },

  orderingServicePrice({ commit }, { productId, orderingData }) {
    return request.post(`/admin/product/${productId}/price/ordering`, orderingData)
  },
  /**
   * @description 排序一般服務
   */
  orderingServicePriceGroup({ commit }, { orderingData }) {
    return request.post(`/admin/service/ordering`, orderingData)
  },
  serviceUpdateState({ commit }, { ids, state } = {}) {
    return request.post('/admin/product/price/state', {
      ids,
      state,
    })
  },

  // 服務分類
  fetchServiceCategory({ commit }, submitData) {
    let baseObj = {
      state: 1,
      type: 'cosmetic',
    }
    let combineObj = {}
    if (submitData) {
      combineObj = Object.assign({}, baseObj, submitData)
    } else {
      combineObj = Object.assign({}, baseObj)
    }
    return request.post(`/admin/service/category/search`, combineObj).then((response) => response.items)
  },
  /**
   * @description 為了多層的擷取，而需要這個api
   */
  fetchServiceCategoryForLeaf({ commit }, query) {
    return request.post(`/admin/service/category/search`, query).then((response) => response.items)
  },
  storeServiceCategory({ commit }, submitData) {
    return request.post(`/admin/service/category/store`, submitData)
  },
  removeServiceCategory({ commit }, ids) {
    return request.post(`/admin/service/category/remove`, ids)
  },
  postServiceCategory({ commit }, query) {
    return request.post(`admin/service/category`, query).then((response) => response.items)
  },
  patchServiceCategory({ commit }, { categoryId, payload }) {
    return request.patch(`admin/service/category/${categoryId}`, payload).then((response) => response.items)
  },
  deleteServiceCategory({ commit }, { categoryId }) {
    return request.delete(`admin/service/category/${categoryId}`).then((response) => response.items)
  },

  // 加購項目
  fetchAdditionalPrices({ commit }, query) {
    return request.post(`/admin/service/additional/search`, query).then(({ items, pagination: { total, current_page } }) => {
      return {
        items,
        total,
        current_page,
      }
    })
  },

  /**
   * @description 獲取加購項目 -> 搜尋資料
   */
  fetchAdditionalService({ commit }, query) {
    return request.post(`/admin/service/search`, query).then((items) => {
      return items
    })
  },
  /**
   * @description 獲取SPA項目 -> 搜尋資料
   */
  fetchSpaService({ commit }, query) {
    return request.post(`/admin/service/price/group/search`, query).then((items) => {
      return {
        items: items,
      }
    })
  },

  storeAdditionalPrice({ commit }, submitData) {
    return request.post(`/admin/service/additional/store`, submitData)
  },
  storeAdditionalPriceGroup({ commit }, submitData) {
    let data = {
      ...submitData,
      images: submitData.images.map((image, index) => {
        return {
          ...image,
          default: index === 0 ? 1 : 0,
        }
      }),
      customServicePrices: [],
    }

    return request.post(`/admin/service/store`, data)
  },
  removeAdditionalPrice({ commit }, submitData) {
    return request.post(`/admin/service/additional/remove`, submitData)
  },
  fetchSingleAdditionalPrice({ commit }, priceId) {
    return request.get(`/admin/service/additional/${priceId}`).then((response) => response.items)
  },
  orderingAdditionalPriceGroup({ commit }, { orderingData }) {
    return request.post(`/admin/service/ordering`, orderingData)
  },
  orderingSpaPriceGroup({ commit }, { orderingData }) {
    return request.post(`/admin/service/price/group/ordering`, orderingData)
  },
  additionUpdateState({ commit }, { ids, state } = {}) {
    return request.post('/admin/service/additional/state', {
      ids,
      state,
    })
  },
  /**
   * @description 上架 or 下架商品
   * @returns
   */
  onMarketorSoldOut({ commit }, submitData) {
    return request.post(`/admin/service/${submitData.service_id}/size/state`, {
      ids: submitData.ids,
      state: submitData.state,
    })
  },
  /**
   * @description 取得規格變化資訊
   */
  postToGetSpecDiff({ commit }, submitData) {
    return request.post(`admin/service/spec/diff`, submitData)
  },
}
